<template>
  <div class="my-account"
    :class="{'en-us': language == 'en_US'}"
  >
    <div class="title">{{$t('MAM_main_account')}}</div>
    <div
      class="card-item front-box"
      v-for="(item,index) in mamMasterList"
      :key="item.mtId"
    >
      <div class="card-top">
        <span
          @click="masterDetaiHandle(item)"
          class="alias top-item pointer">{{item.alias || item.login}}</span>
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          v-if="item.isOpen"
        >
          <div class="" slot="content">{{$t('copyMaster.public')}}</div>
          <span
              class="icon-box top-item">
            <icon-svg
              icon-class="eye"
              class="icon-el"
            />
          </span>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          v-if="!item.isOpen"
        >
          <div class="" slot="content">{{$t('copyMaster.private')}}</div>
          <span
              class="icon-box red-bg top-item">
            <icon-svg
              icon-class="bugongkai"
              class="icon-el"
            />
          </span>
        </el-tooltip>
<!--        订阅密码 -->
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          v-if="item.isOpen && item.isEncrypt"
        >
          <div class="" slot="content">{{$t('copyMaster.Have_a_subscription_password')}}</div>
          <span
              class="icon-box red-bg top-item">
            <icon-svg
              icon-class="youdingyuemima"
              class="icon-el"
            />
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          v-if="item.isOpen && !item.isEncrypt"
        >
          <div class="" slot="content">{{$t('copyMaster.No_subscription_password')}}</div>
          <span
              class="icon-box top-item">
            <icon-svg
              icon-class="wudingyuemima"
              class="icon-el"
            />
          </span>
        </el-tooltip>
        <div
          class="real-tag tag theme-color top-item"
          :style="themeOpacty"
        >{{$t('customerHome.MAM_master')}}</div>
        <div class="mt4-tag tag">MT4</div>
      </div>
      <el-row class="content-module">
        <el-col
          :xl="16"
          :lg="16"
          :md="24"
          :sm="24"
          :xs="24"
          class="data-box col-el">
          <el-row :gutter="5">
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('account')}}</div>
                <div class="data">{{item.login}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('Management_income')}}</div>
                <div
                  class="data"
                  :class="{
                  green: !(item.managementProfit + '').includes('-') ,
                  red: (item.managementProfit + '').includes('-'),
                  }"
                >{{item.managementProfit}} {{currency}}</div>
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('User.reportEquity')}}</div>
                <div
                  class="data"
                >{{item.equity}} {{currency}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('management_rate_of_return')}}</div>
                <div
                  class="data"
                  :class="{
                    green: !item.averageRate.includes('-'),
                    red: item.averageRate.includes('-'),
                  }"
                >{{item.averageRate}}</div>
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('balance')}}</div>
                <div class="data">{{item.balance}} {{currency}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('Manage_funds')}}</div>
                <div class="data">{{item.managementAmount}} {{currency}}</div>
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('state')}}</div>
                <mt4-status
                  :account-info="getItem(item)"
                ></mt4-status>
              </div>
              <div class="col-item">
                <div class="text">{{$t('copyMaster.Number_of_managed_accounts')}}</div>
                <div class="data">{{item.managementLoginNumber}}</div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :xl="8"
          :lg="8"
          :md="24"
          :sm="24"
          :xs="24"
          class="do-box col-el"
        >
          <div class="do-box">
            <el-button
              class="neededit-btn"
              @click="depositHandle"
            >{{$t('User.in')}}</el-button>
            <el-button
              class="neededit-btn"
              @click="withdrawHandle"
            >{{$t('User.out')}}</el-button>
            <el-button
              class="neededit-btn"
              @click="tradeHandle(item)"
            >{{$t('trade')}}</el-button>
            <account-operate
              @transferHandle="transferHandle(item)"
              @leverHandle="leverHandle(item)"
              @passwordHandle="passwordHandle(item)"
              @copySetHandle="masterCopySetHandle(item)"
              @detailHandle="masterDetaiHandle(item)"
            ></account-operate>
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      v-if="mamMasterList !== null && !mamMasterList.length"
      class="no-data">{{$t('root.noData')}}</div>

    <div class="title">{{$t('MAM_Investor')}}</div>
    <div
      class="card-item"
      v-for="(item,index) in mamSubList"
      :key="item.mtId"
    >
      <div class="card-top">
        <span
          @click="subDetaiHandle(item)"
          class="alias top-item pointer">{{item.alias || item.login}}</span>
        <!--是否订阅中-->
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          v-if="item.isSubscribing"
          :content="$t('Subscribing')"
        >
          <span
              class="icon-box top-item">
            <icon-svg
              icon-class="dingyuezhong"
              class="icon-el"
            />
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          v-if="!item.isSubscribing"
          placement="top"
          :content="$t('copyMaster.No_subscription_yet')"
        >
          <span
              class="icon-box red-bg top-item">
            <icon-svg
              icon-class="zanwudingyue"
              class="icon-el"
            />
          </span>
        </el-tooltip>
        <div
          class="real-tag tag theme-color top-item"
          :style="themeOpacty"
        >{{$t('customerHome.MAM_invest')}}</div>
        <div class="mt4-tag tag">MT4</div>
      </div>
      <el-row class="content-module">
        <el-col
          :xl="16"
          :lg="16"
          :md="24"
          :sm="24"
          :xs="24"
          class="data-box col-el">
          <el-row :gutter="5">
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('account')}}</div>
                <div class="data">{{item.login}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('Subscription_revenue')}}</div>
                <div
                  class="data"
                  :class="{
                  green: +item.profitAmount > 0 ,
                  red: +item.profitAmount < 0,
                  }"
                >{{item.profitAmount}} {{currency}}</div>
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('User.reportEquity')}}</div>
                <div
                  class="data"
                >{{item.equity}} {{currency}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('Subscription_yield')}}</div>
                <div
                  class="data"
                  :class="{
                    green: !item.profitRate.includes('-') ,
                    red: item.profitRate.includes('-'),
                  }"
                >{{item.profitRate}}</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :span="6"
            >
              <div class="col-item">
                <div class="text">{{$t('balance')}}</div>
                <div class="data">{{item.balance}} {{currency}}</div>
              </div>
              <div class="col-item">
                <div class="text">{{$t('copyMaster.copy_pay')}}</div>
                <div class="data">{{item.amountSum}} {{currency}}</div>
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
            >
              <div class="col-item">
                <div class="text">{{$t('state')}}</div>
                <mt4-status
                  :account-info="getItem(item)"
                ></mt4-status>
              </div>
              <div class="col-item">
                <div class="text">{{$t('copyMaster.Subscription_time')}}</div>
                <div class="data">{{matchTime(item.subDays)}}</div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :xl="8"
          :lg="8"
          :md="24"
          :sm="24"
          :xs="24"
          class="do-box col-el"
        >
          <div class="do-box">
            <el-button
              class="neededit-btn"
              @click="depositHandle"
            >{{$t('User.in')}}</el-button>
            <el-button
              class="neededit-btn"
              @click="withdrawHandle"
            >{{$t('User.out')}}</el-button>
            <el-button
              class="neededit-btn"
              @click="tradeHandle(item)"
            >{{$t('trade')}}</el-button>
            <account-operate
              @transferHandle="transferHandle(item)"
              @leverHandle="leverHandle(item)"
              @passwordHandle="passwordHandle(item)"
              @copySetHandle="subCopySetHandle(item)"
              @detailHandle="subDetaiHandle(item)"
            ></account-operate>
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      v-if="mamSubList !== null && !mamSubList.length"
      class="no-data">{{$t('root.noData')}}</div>
<!--    <el-table
      :data="listData"
      size="mini"
      style="width: 100%"
      class="mam-list-table small-el-table"
      @sort-change="sortChange"
      :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
    >
      <div class="table-nodata" slot="empty">
        {{$t('root.noData')}}
      </div>
      <el-table-column
        :label="$t('serial_number_num')"
      >
        <template slot-scope="scope">
          <span>{{scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('nickname')"
        min-width="150px"
      >
        <template slot-scope="scope">
          <span
            @click="detaiHandle(scope.row)"
            class="pointer"
          >{{scope.row.alias || scope.row.login}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="login"
        :label="$t('withgold.accountNumber')"
        min-width="100px"
      >
        <template slot-scope="scope">
          <div
            class="pointer"
            @click="detaiHandle(scope.row)"
          >
            {{scope.row.login}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="accType"
        min-width="120px"
        :label="$t('User.accType')"
      >
        <template slot-scope="scope">
          <span class="tag-box">{{getAccountType(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="profitAmount"
        :label="$t('Personal_gain')"
        sortable
        min-width="120px"
      >
      </el-table-column>
      <el-table-column
        prop="profitRate"
        :label="$t('rate_of_return')"
        sortable
        min-width="100px"
      >
        <template slot-scope="scope">
          <span
            class="profit-rate"
            :class="{
              green: !scope.row.profitRate.includes('-'),
              red: scope.row.profitRate.includes('-')
            }"
          >{{scope.row.profitRate}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="subCount"
        :label="$t('Subscribe_to_the_number_of')"
        sortable
        min-width="120px"
      >
      </el-table-column>
      <el-table-column
        :label="$t('withgold.operating')"
        align="center"
      >
        <template slot-scope="scope">
          <account-operate
            @transferHandle="transferHandle(scope.row)"
            @leverHandle="leverHandle(scope.row)"
            @accountHandle="accountHandle(scope.row)"
            @detailHandle="detaiHandle(scope.row)"
          ></account-operate>
        </template>
      </el-table-column>
    </el-table>-->
    <leverage-setting
      ref="leverdialog"
      :cur-login="curLogin"
      :dialogShow="leverDialogShow"
      @close="leverDialogCloseHandel"
      @ajax-success="leverSettingSuccessHandle"
    ></leverage-setting>
    <mt4-password-setting
      ref="passworddialog"
      :dialogShow="setPasswordDialogShow"
      :is-man-invertor="isMmanInvertor"
      @close="passwordDialogCloseHandel"
      :cur-login="curLogin"
      @ajax-success="passwordSettingSuccessHandle"
    ></mt4-password-setting>
    <mt4-info-dialog
      ref="infodialog"
      :account-info="currentAccountInfo"
    ></mt4-info-dialog>
    <down-mt4-dialog
      ref="downdialog"
      :account-info="currentAccountInfo"
    ></down-mt4-dialog>
    <mam-master-copy-setting-dialog
      :dialog-show="masterCopySetDialogShow"
      :account-mt-id="currentAccountInfo.mtId"
      @close="masterCopySetDialogShow = false"
      @ajax-success="masterSetSuccess"
    ></mam-master-copy-setting-dialog>

    <sub-master-copy-setting-dialog
      :dialog-show="subCopySetDialogShow"
      :account-mt-id="currentAccountInfo.mtId"
      @close="subCopySetDialogShow = false"
      @ajax-success="subSetSuccess"
    ></sub-master-copy-setting-dialog>
  </div>
</template>

<script>
import mt4Status from "@/components/public/mt4Status";
import subMasterCopySettingDialog from "@/components/copyMaster/home/subMasterCopySettingDialog";
import mamMasterCopySettingDialog from '@/components/copyMaster/home/mamMasterCopySettingDialog'
import downMt4Dialog from "@/components/public/downMt4Dialog";
import mt4InfoDialog from "@/components/public/mt4InfoDialog";
import mt4PasswordSetting from "@/components/public/mt4PasswordSetting";
import leverageSetting from "@/components/public/leverageSetting";
import  accountOperate from "@/components/copyMaster/home/accountOperate";
import { mapGetters } from 'vuex'
import { queryAccountLimit } from '@/api/userCenter.js';
import { colorRgba } from "@/utils";
import { matchTime } from "@/utils/common";
export default {
  name: 'myMamAccountList',
  components:{
    accountOperate,
    leverageSetting,
    mt4PasswordSetting,
    mt4InfoDialog,
    downMt4Dialog,

    mamMasterCopySettingDialog,
    subMasterCopySettingDialog,
    mt4Status,
  },
  data() {
    let _this = this;
    return {
      mamMasterList: null,
        /*{
          mtId: 2459,
          alias: '在路上干货',
          isOpen: 1,
          login: 9008888,
          equity: '$100.00',
          balance: '$100.00',
          enableReadOnly: 0,
          manageProfit: '$1000.00',
          managementRate: '11.91%',
          manageFunds: '$34700.00',
          managedAccounts: 8,
        }*/
      mamSubList: null,
        /*{
          mtId: 2726,
          alias: '在路上干货',
          isOpen: 1,
          login: 9008888,
          equity: '$100.00',
          balance: '$100.00',
          enableReadOnly: 0,

          copyProfit: '-$1000.00',
          copyRate: '-11.91%',
          copy_pay: '$1000.00',
          copyMonth: 8,
        },*/

      accountTypeList:[
        {label: _this.$t('MAM_master_account'), value: 1,},
        {label: _this.$t('MAM_Investment_Account'), value: 2,},
      ],
      canOpenAccountCount: 0,

      curLogin: 0, // 杠杆设置,
      leverDialogShow: false,
      setPasswordDialogShow: false,
      currentAccountInfo: {},

      // 跟单设置
      masterCopySetDialogShow: false,
      subCopySetDialogShow: false,

      isMmanInvertor: false,
    };
  },
  created() {
    this.getMasterList();
    this.getSubList();
    /*custStatus
  1, "注册未申请",
  2, "已申请未开户",
  3, "开户未入金",
  4, "入金未交易",
  5, "已交易",
  6, "销户",
  10, "注册未激活";*/

    /*  auditStatus:
    1, "客服审核",
    2, "交易部审核",
    3, "审核拒绝",
    4, "审核通过",
    5, "冻结",
    6, "销户",
    7, "账户信息复审";*/

    if(this.userInfo.id){
      this.queryAccountCount();
    }

  },
  watch:{
    listRefresh(){
      this.getMasterList();
      this.getSubList();
    },
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','listRefresh','themeColor','language']),
    themeOpacty(){
      return {
        background: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    },
    currency(){
      return 'USD';
    }
  },
  beforeDestroy(){
    this.$store.commit('setOpenAccountRole','');
  },
  methods: {
    matchTime,
    masterSetSuccess(){
      this.masterCopySetDialogShow = false;
      this.getMasterList();
      this.$forceUpdate();
    },
    subSetSuccess(){
      this.subCopySetDialogShow = false;
      this.getSubList();
      this.$forceUpdate();
    },
    getItem(item){
      let copyItem = JSON.parse(JSON.stringify(item));
      // copyItem.balance = copyItem.balance.replace('$','');
      return copyItem;
    },
    getMasterList(){
      let params = {
        tier: 1,
      }
      this.$http({
        url: '/crm/reception/mamAccList',
        method: 'get',
        params: params,
        addToken:true,
      }).then((res) => {
        this.mamMasterList = res.data;
      });
    },

    getSubList(){
      let params = {
        tier: 2,
      }
      this.$http({
        url: '/crm/reception/mamAccList',
        method: 'get',
        params: params,
        addToken:true,
      }).then((res) => {
        console.log(res.data);
        this.mamSubList = res.data;
      });
    },
    queryAccountCount(){
      queryAccountLimit({
        custId: this.userInfo.id,
      }).then((res) => {
        this.canOpenAccountCount = res.data.limit;
      })
    },
    openAccountHandle(){
      if(this.canOpenAccountCount === 0) return;
      this.$store.commit('setOpenAccountDialogShow', true);
    },
    getAccountType(row){
      return row.tier == 1 ? this.$t('MAM_master_account'): this.$t('MAM_Investment_Account');
    },
    getStatus(row){
      return row.enableReadonly == 0 ? this.$t('User.startUsing'): this.$t('User.forbidden');
    },

    // 账户操作 start
    transferHandle(item) {
      this.$store.commit('setDepositAccount',item.login);
      this.$router.push({name: 'transfers'});
    },
    leverHandle(item){
      this.curLogin = item.login;
      this.leverDialogShow = true;
    },
    // 杠杆设置弹框关闭
    leverDialogCloseHandel(){
      this.curLogin = 0;
      this.leverDialogShow = false;
    },
    // 设置杠杆成功
    leverSettingSuccessHandle(){
      this.curLogin = 0;
      this.$emit('refresh-list');
      this.leverDialogShow = false;
    },
    // 设置密码 start
    passwordHandle(accountInfo){
      this.curLogin = accountInfo.login;
      this.setPasswordDialogShow = true;
      if(accountInfo.tier == 1){
        this.isMmanInvertor = false;
      }else if(accountInfo.tier == 2){
        this.isMmanInvertor = true;
      }
    },
    passwordDialogCloseHandel(){
      this.curLogin = 0;
      this.setPasswordDialogShow = false;
    },
    // 设置密码成功
    passwordSettingSuccessHandle(){
      this.curLogin = 0;
      this.setPasswordDialogShow = false;
      this.$message({
        message: this.$t('User.passSetSuccess'),
        type: 'success'
      });
    },
    masterCopySetHandle(accountInfo){
      this.currentAccountInfo = accountInfo;
      this.masterCopySetDialogShow = true;
    },
    subCopySetHandle(accountInfo){
      this.currentAccountInfo = accountInfo;
      this.subCopySetDialogShow = true;
    },
    // 账户操作 end
    masterDetaiHandle(row){
      localStorage.setItem('goBackRouterName','copyMaster');
      this.$router.push({name: 'mamMasterDetails', params: {mtid: row.mtId}});
    },
    subDetaiHandle(row){
      if(row.isSubscribing || row.subDays > 0 ){
        localStorage.setItem('goBackRouterName','copyMaster');
        this.$router.push({name: 'mamSubDetails', params: {mtid: row.mtId}});
      }else {
        this.$message({
          type: 'warning',
          message: this.$t('copyMaster.Please_subscribe_to_the_trader_first_and_then_view_the_details'),
        })
      }
    },

    //操作部分
    // 入金
    depositHandle(){
      this.$router.push({name: 'depositFunds'});
    },
    // 出金
    withdrawHandle(){
      this.$router.push({name: 'withdraw'});
    },
    // 交易
    tradeHandle(accountInfo){
      console.log(accountInfo);
      this.currentAccountInfo = accountInfo;
      this.$refs.downdialog.dialogShow = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.my-account {
  &.en-us {
    .neededit-btn {
      font-size: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  .title {
    margin-bottom: 12px;
  }
  .alias,
  .title {
    font-weight: 600;
    font-size: 16px;
  }
  .card-item {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 20px 24px;
    margin-bottom: 20px;
    .card-top {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 12px;
      .top-item {
        margin-right: 8px;
      }
    }
    .icon-box {
      display: inline-block;
      background-color: #41B883;
      &.red-bg {
        background-color: #D85E5F;
      }
      width: 18px;
      height: 18px;
      border-radius: 5px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon-el {
        font-size: 12px;
      }
    }

    .content-module {
      .data-box {
        font-size: 14px;
        .col-item {
          margin-bottom: 10px;
          .text {
            color: #B9B9C3;
          }
        }
      }
    }
  }
  .front-box {
    margin-bottom: 20px;
  }
  .tag-box {
    display: inline-block;
    white-space: nowrap;
    background-color: rgba(186,191,199, .2);
    border-radius: 15px;
    padding: 0 10px;
  }
  .green {
    color: #28C76F;
  }
  .red {
    color: #EA5455;
  }

  .no-data {
    height: 100px;
    line-height: 100px;
    text-align: center;
  }


}
@media screen and (min-width: 992px){
  .do-box {
    padding-top: 8px;
  }
}

@media screen and (max-width: 1440px){
  .col-el {
    width: 100%!important;
  }
  .do-box {
    text-align: left;
  }
}
</style>
<style lang="scss">


</style>
